import { useCallback, useState } from 'react';
import { createEngagementClient } from '../../../../src/services/client';
import { REMOVE_FAVORITE_CONTENT } from '../engagementGql/favoriteContent';
import { addErrorInDatadogRum } from '../utils/utilities';

const WORKOUT_CONTENT_TYPE = 'workout';

type RemoveFavoriteWorkoutParams = {
  programName: string;
  workoutName: string;
};

const useRemoveFavoriteWorkout = () => {
  const [isProcessing, setIsProcessing] = useState(false);

  const removeFavoriteWorkout = useCallback(
    async ({ programName, workoutName }: RemoveFavoriteWorkoutParams) => {
      setIsProcessing(true);
      try {
        await createEngagementClient.mutate({
          mutation: REMOVE_FAVORITE_CONTENT,
          variables: {
            contentType: WORKOUT_CONTENT_TYPE,
            contentId: `${programName}|${workoutName}`,
          },
        });
      } catch (error) {
        addErrorInDatadogRum(error);
      } finally {
        setIsProcessing(false);
      }
    },
    []
  );

  return { removeFavoriteWorkout, isProcessing };
};

export default useRemoveFavoriteWorkout;
